<template>
  <div>
    <!-- 弹出层 -->
    <div class="modal" :class="show?'is-active':''">
      <div class="modal-background"></div>
      <div
      class="modal-content">
        <slot></slot>
      </div>
      <!-- <button class="modal-close is-large" @click="close()"></button> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['show'],
  methods: {
    close () {
      this.$emit('close')
    }
  },
  mounted () {
  }
}
</script>
<style>
.modal .modal-content {
  width: 1000px;
  display: flex;
  justify-content: center;
  margin-top: -80px;
}

.modal.is-active {
  z-index: 101;
}

.modal .modal-background{
  background-color: rgba(10, 10, 10, 0.4);
}

.modal video {
  width: 100%;
  height: 100%;
}
</style>
